export class Message {
    constructor(msg, error = true, timeout = 5000) {
        this._message = msg;
        this._messageElement = document.querySelector(".message");
        this._timeout = timeout;
        this._error = error;
        this.show();
    }

    show() {
        if(this._messageElement && this._message){
            if(!this._error)
                this._messageElement.classList.add('message--success')

            this._messageElement.querySelector(".message__box-content").innerHTML = ""
            this._messageElement.querySelector(".message__box-content").innerHTML = this._message
            this._messageElement.style.display = 'flex'

            setTimeout(() => {
                this._messageElement.style.display = 'none'
                if(!this._error)
                    this._messageElement.classList.remove('message--success')
            }, this._timeout)
        }
    }

    set message(msg) {
        this._message = msg;
    }

    set timeout(timeout) {
        this._timeout = timeout;
    }

    set error(error) {
        this._error = error;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/message.js